import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import '../css/landing_page.css';

export default function LandingPage() {
  return (
    <>
      <Helmet>
        <title>Ballhead</title>
        <meta property="og:title" content="Ballhead" key="og:title" />
        <meta property="og:description" content="Explore commands, apply for roles, and access the internal dashboard for Ballhead." key="og:description" />
        <meta property="og:image" content="https://cdn.ballhead.app/web_assets/logo.png" key="og:image" />
        <meta property="og:url" content="https://ballhead.app" key="og:url" />
        <meta property="og:type" content="website" key="og:type" />
        <meta name="twitter:card" content="summary_large_image" key="twitter:card" />
        <meta name="twitter:title" content="Ballhead" key="twitter:title" />
        <meta name="twitter:description" content="Explore commands, apply for roles, and access the internal dashboard for Ballhead." key="twitter:description" />
        <meta name="twitter:image" content="https://cdn.ballhead.app/web_assets/logo.png" key="twitter:image" />
      </Helmet>
    <div className="landing-container">
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="landing-title">Meet Ballhead</h1>
          <p className="landing-subtitle">Your favorite Gym Class companion</p>
          <nav className="landing-nav">
            <Link to="/dashboard" className="landing-link">Dashboard</Link>
            <Link to="/documentation" className="landing-link">Documentation</Link>
            <Link to="/apply" className="landing-link">Applications</Link>
          </nav>
        </div>
        <div className="hero-logo-container">
          <div className="wave-emoji">👋</div>
          <img
            src="https://cdn.ballhead.app/web_assets/logo.png"
            alt="Ballhead Logo"
            className="hero-logo"
          />
        </div>
      </div>
    </div>
    </>
  );
}
